import useSWR from "swr";
import { useAxiosWithAuth } from "/utils/hooks/useAxiosAPI";
import { useEffect } from "react";

const bundlesOLD = [
  {
    name: "CONTENDER BUNDLE",
    visual: "/bundles/bundle-1.png",
    price: 200,
    usd: 8,
    uuid: "9e11b880-90e0-4a07-81aa-b44cc71f0444",
    data: [
      { name: "2x Funtico Fan Tickets", icon: "/bundles/fan.png" },
      { name: "2x Private Passes", icon: "/bundles/private.png" },
      { name: "10x Tico Bar Spins", icon: "/bundles/spin.png" },
      {
        name: "2x Contender Vouchers",
        icon: "/bundles/contender-vouchers.png",
      },
    ],
  },
  {
    name: "CHALLENGER BUNDLE",
    visual: "/bundles/bundle-2.png",
    price: 3750,
    usd: 15,
    uuid: "9e11b8a1-63d2-4d37-acfa-e067ec856806",
    data: [
      { name: "5x Funtico Fan Tickets", icon: "/bundles/fan.png" },
      { name: "4x Private Passes", icon: "/bundles/private.png" },
      { name: "25x Tico Bar Spins", icon: "/bundles/spin.png" },
      {
        name: "3x Challenger Vouchers",
        icon: "/bundles/challenger-vouchers.png",
      },
      {
        name: "3x Multiplier Ticket ★★",
        icon: "/bundles/multiplier-ticket.png",
      },
    ],
  },
  {
    name: "CHAMPION BUNDLE",
    visual: "/bundles/bundle-3.png",
    price: 6250,
    usd: 25,
    uuid: "9e11b8d8-b6e6-4a83-b12c-690177c7fe65",
    data: [
      { name: "10x Funtico Fan Tickets", icon: "/bundles/fan.png" },
      { name: "10x Private Passes", icon: "/bundles/private.png" },
      { name: "75x Tico Bar Spins", icon: "/bundles/spin.png" },
      { name: "7x Champion Vouchers", icon: "/bundles/champion-vouchers.png" },
      {
        name: "5x Multiplier Ticket ★★★",
        icon: "/bundles/multiplier-ticket.png",
      },
    ],
  },
];
const bundles = [
  {
    name: "FUNTICO FAN TICKETS",
    visual: "/bundles/FUNTICO-FAN-TICKETS.webp",
    price: 3750,
    usd: 1,
    uuid: "a058b869-3cc6-46b0-8b03-649a112b5694",
  },
];

const howToBuy = [
  {
    name: "Credit <br> Card**",
    link: "",
    icon: "/buy/card.png",
  },
  {
    name: "Decentralized Exchange <br> - 0% fee -",
    link: "https://app.uniswap.org/swap?chain=avalanche&inputCurrency=0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E&outputCurrency=0xedf647326007e64d94b0ee69743350f3736e392c",
    icon: "/buy/dex.png",
  },
  {
    name: "Centralized Exchange",
    link: "https://gate.io/trade/TICO_USDT",
    icon: "/buy/cex.png",
  },
];

export const useBundles = () => {
  const axiosClient = useAxiosWithAuth();
  const { isLoading, data, error } = useSWR(
    ["store", []],
    ([path, filters]) =>
      axiosClient.wrap(
        axiosClient.get(path, {
          params: {
            filters,
          },
        })
      ),
    {
      fallbackData: { data: [] },
    }
  );

  if (error || isLoading) {
    return bundles;
  }

  const getBundleData = (bundleUuid) => {
    const bundle = data.data.find((item) => item.id === bundleUuid);

    if (!bundle) {
      return {};
    }

    return {
      price: bundle.price,
      itemId: bundle.item.id,
      data: bundle.details
        .map((bundleItem) => ({
          name: `${bundleItem.amount}X ${bundleItem.name}`,
          icon: bundleItem.image,
        }))
        .reverse(),
    };
  };

  return bundles.map((bundle) => ({
    ...bundle,
    ...getBundleData(bundle.uuid),
  }));
};

export { bundles, howToBuy };
